import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import axios from "axios";
// --- Import Redux
import { connect } from "react-redux";
// --- Import Funtions
import readCookie from "../../../hooks/readCookie";
import createCookie from "../../../hooks/createCookie";
import createGuid from "../../../hooks/createGuid";
import pixelEvent from "../../../hooks/pixelEvent";
// --- Import Styles
import "./HelpCenter.sass";

const tawkToPropertyId = "61419a5f25797d7a89ff090f";
const tawkToKey = "default";

const fcid = readCookie("_fcid");
const guid = createGuid();

function HelpCenter({ userData }) {
  const tawkMessengerRef = useRef();
  const chatId = useRef();
  const [chatLoaded, setChatLoaded] = useState(false);

  function sendEvents(fieldName, response) {
    const url =
      process.env.NODE_ENV === "development"
        ? "http://pcappstore.loc/api/api.php"
        : "/api/api.php";

    if (!chatId.current) {
      chatId.current = Date.now();
    }
    axios
      .post(url, {
        c: "front",
        a: "tawkTo",
        p: {
          guid,
          _fcid: fcid,
          _cid: readCookie("_cid"),
          action: fieldName,
          message: response,
          chatId: chatId.current,
        },
      })
      .then((res) => {
        if (!readCookie("_cid")) {
          const newCid = res.data.result._cid; // eslint-disable-line no-underscore-dangle
          createCookie("_cid", newCid);
        }
      });
  }

  function handleToogle() {
    tawkMessengerRef.current.toggle();
    pixelEvent({
      evt_src: "acct",
      evt_action: "click_help",
      guid,
    });
  }

  function onLoad() {
    setChatLoaded(true);
    const fullName =
      userData !== null ? `${userData.first_name} ${userData.last_name}` : "";
    const email = userData !== null ? userData.email : "";

    const paramsToSet = {};

    if (fullName && readCookie("_cid")) {
      paramsToSet.name = `${fullName} (${readCookie("_cid")})`;
    }
    if (email) {
      paramsToSet.email = email;
    }

    window.Tawk_API.setAttributes({
      ...paramsToSet,
    });
  }

  return (
    <>
      <TawkMessengerReact
        ref={tawkMessengerRef}
        propertyId={tawkToPropertyId}
        widgetId={tawkToKey}
        onLoad={() => onLoad()}
        onChatMessageVisitor={(message) => {
          sendEvents("visitorMess", message);
        }}
        onChatMessageAgent={(message) => {
          sendEvents("agentMess", message);
        }}
        onChatMessageSystem={(message) => {
          sendEvents("systemMess", message);
        }}
        onAgentJoinChat={(data) => {
          sendEvents("agentJoin", data);
        }}
        onAgentLeaveChat={(data) => {
          sendEvents("agentLeave", data);
        }}
        onChatSatisfaction={(satisfaction) => {
          sendEvents("chatSatisfaction", satisfaction);
        }}
        onVisitorNameChanged={(visitorName) => {
          sendEvents("visitorNameChanged", visitorName);
        }}
        onFileUpload={(link) => {
          sendEvents("fileUploaded", link);
        }}
        onChatEnded={() => {
          sendEvents("chatEnded", "Chat ended");
        }}
        // onChatStarted={() => {
        //   sendEvents("chatStarted", "Chat started");
        // }}
      />

      {chatLoaded && (
        <button className="helpCenterBtn" onClick={handleToogle}>
          Help Center
        </button>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  userData: state.userDataStore.userData,
});

const mapDispatchToProps = {};

HelpCenter.propTypes = {
  userData: PropTypes.objectOf(PropTypes.string),
};

HelpCenter.defaultProps = {
  userData: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpCenter);
